module.exports = __webpack_public_path__ + "img/hermes-cod.f85a1789.png";